














import Vue from 'vue';

import { Portal } from 'portal-vue';

class ModalOrder {
    static current = 1;
    static next(): number {
        return ModalOrder.current++;
    }
}

export default Vue.extend({
    name: 'Modal',
    components: {
        Portal,
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        center: {
            // Should content be centered
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            order: 0,
        };
    },
    watch: {
        show: {
            immediate: true,
            handler(show: boolean) {
                if (show) {
                    this.order = ModalOrder.next();
                }
            },
        },
    },
});
